import React, { useState } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import CheckIcon from "@material-ui/icons/Check";

export default function CopyTextButton({ value, label, attached = false }: { value: string; label: string; attached?: boolean }) {
  const [status, setStatus] = useState<"idle" | "copied" | "failed">("idle");
  const message = status === "copied" ? `${label} kopiert` : status === "failed" ? "Kopieren fehlgeschlagen – bitte Text markieren" : `${label} kopieren`;
  return <>
    <Tooltip title={message} placement="top" arrow enterDelay={350}>
      <IconButton className={attached ? "cms-team-email-copy" : undefined} data-copied={status === "copied" || undefined} size="small" aria-label={message} onBlur={() => setStatus("idle")}
        style={{ color: status === "copied" ? "#007f9e" : "#53616b", flexShrink: 0, width: attached ? 40 : 32, minHeight: attached ? 40 : 32, alignSelf: attached ? "stretch" : undefined, borderRadius: attached ? 0 : "50%", borderLeft: attached ? "1px solid #e1e5e9" : undefined }}
        onClick={async event => {
          event.stopPropagation();
          try {
            await navigator.clipboard.writeText(value.trim());
            setStatus("copied");
          } catch {
            setStatus("failed");
          }
        }}>
        {status === "copied" ? <CheckIcon fontSize="small" /> : <FileCopyOutlinedIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
    <span role="status" style={{ position: "absolute", width: 1, height: 1, padding: 0, overflow: "hidden", clip: "rect(0, 0, 0, 0)" }}>{status === "idle" ? "" : message}</span>
  </>;
}
